import { useLayoutEffect } from 'react';

function useScrollTop(...dependencies) {
  useLayoutEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

export default useScrollTop;
